export default __webpack_public_path__ + "static/media/BarlowSemiCondensed-Bold.64541955.ttf";